module.exports = __webpack_public_path__ + "img/194-Gris Béton Lisse.jpg";